"use client";

// import ScheduleDemo from "@/features/onboarding/login/Schedule-demo";
import { Button } from "@/pages/newHome/ui/button";
import { Card, CardContent } from "@/pages/newHome/ui/card";
import { useNavigate } from "react-router-dom";
// import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "@/store";

export const FrameByAnima = (): JSX.Element => {
    const navigate = useNavigate();
    const user = useSelector(
      (state: RootState) => state.rootReducer.userReducer.user
    );
  return (
    <section className="min-h-[90vh] relative w-full py-16 md:py-20 flex flex-col items-center justify-center gap-8 px-4 sm:px-6 overflow-hidden">
      {/* Dot Background */}
      <div className="absolute inset-0 -z-10">
        <div
          className="absolute inset-0 opacity-10"
          style={{
            backgroundImage:
              "radial-gradient(circle at center, #000000 2px, transparent 1px)",
            backgroundSize: "24px 24px",
            backgroundPosition: "0 0",
            width: "100%",
            height: "100%",
          }}
        />
      </div>

      {/* Quote */}
      <Card className="border-none shadow-none bg-transparent w-full max-w-3xl relative">
        <CardContent className="p-0">
          <h2 className="font-outfit text-center leading-tight text-[7vw] sm:text-3xl md:text-4xl lg:text-5xl font-bold">
            <span className="text-black">“BuildMapper has all the tools to </span>
            <span className="text-green-500">supercharge </span>
            <span className="text-black">any sales team in construction”</span>
          </h2>
        </CardContent>
      </Card>

      {/* Button */}
      {/* <ScheduleDemo>
        <Button className="rounded-full h-[50px] bg-primary cursor-pointer px-6 sm:px-8 py-3 sm:py-4 text-[16px] md:text-lg sm:text-xl font-medium text-white hover:bg-[#239e41]">
          Get Started
        </Button>
      </ScheduleDemo> */}
      <Button
        onClick={(e) => {
          if (user) {
            e.preventDefault();
            navigate("/dashboard/explore_leads");
          } else {
            // window.open("https://buildmapper.typeform.com/to/oVrzJex7", "_blank");
            //  window.open(`${window.location.origin}/newOnboarding`, "_self");
            navigate("auth/signup")
          }
        }}
        className="sm:w-40 h-[50px] rounded-[40px] bg-primary hover:bg-[#239e41] shadow-none text-[16px] md:text-lg sm:text-xl font-medium text-white"
      >
        Get Started
      </Button>
    </section>
  );
};
